import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@app/_models';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JiraConfigService {

  constructor(private http: HttpClient) { }

  activeDefect(executionTypeId): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(environment.apiUrl + 'jira/activeDefect/' + executionTypeId);
  }
}
